import React, { useEffect, useState } from "react"
import styled from "styled-components"

import { Crosshead } from "~/components/Crosshead"
import { HorizontalItems } from "~/components/HorizontalItems"
import { Thumbnail } from "~/components/Thumbnail"
import { useTrackingNew } from "~/contexts/Tracking"
import { prefixNumber } from "~/libs/analytics"
import { migrateHistories } from "~/libs/migration"
import { addPlayHistory, getPlayHistories, setPlayHistories } from "~/libs/storage"
import { thumbnailSize } from "~/libs/style"

type GamesProps = {
  games: Array<{
    gameId: number
    // app_id: number
    title: string
    text: string
    url: string
    image: {
      url: string
    }
    banner: string
    thumbnail: string
  }>
}

const useHistories = (games: GamesProps["games"]) => {
  const [historyGames, setHistoryGames] = useState<GamesProps["games"]>([])
  useEffect(() => {
    migrateHistories()

    const gameIds = getPlayHistories()
    const newHistoryGames = gameIds
      .map((gameId) => games.find((game) => game.gameId == gameId))
      .filter((game): game is NonNullable<typeof game> => game !== undefined)

    setPlayHistories(newHistoryGames.map((historyGame) => historyGame.gameId))

    if (newHistoryGames.length) {
      setHistoryGames(newHistoryGames)
    }
  }, [])

  return historyGames
}

export const History: React.FC<GamesProps> = ({ games }) => {
  const historyGames = useHistories(games)
  const { analyticsTrack } = useTrackingNew()
  const categoryTracking = "有料Top_最近プレイしたゲーム"
  if (!historyGames.length) {
    return null
  }

  return (
    <Wrapper>
      <Crosshead>最近チェックしたゲーム</Crosshead>
      <HorizontalItems>
        {historyGames.map((game, index) => (
          <Item key={index}>
            <HorizontalLink
              key={index}
              href={game.url}
              onClick={(event: React.MouseEvent<HTMLAnchorElement>) => {
                analyticsTrack(event, categoryTracking, `${prefixNumber(index + 1)}個目`, `${game.title}：${game.url}`)
                addPlayHistory(game.gameId)
              }}
            >
              <Thumbnail src={game.image.url} />
              <GameTitle>{game.title}</GameTitle>
            </HorizontalLink>
          </Item>
        ))}
      </HorizontalItems>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  margin: 20px 0;
  h2 {
    background: unset;
    border-top: thin solid #e9e9e9;
    margin: 0px 10px;
    padding: 10px 0px;
  }
`

const HorizontalLink = styled.a`
  position: relative;
  display: block;
  width: ${thumbnailSize}px;
  padding: 5px 0;
`

const Item = styled.li`
  a {
    margin-right: 5px;
  }
  &:last-child a {
    margin-right: 10px;
  }
  img {
    border-radius: 10px;
  }
`

const GameTitle = styled.p`
  /* stylelint-disable-next-line value-no-vendor-prefix */
  display: -webkit-box;
  /* stylelint-disable-next-line property-no-vendor-prefix */
  -webkit-box-orient: vertical;
  margin-top: 5px;
  -webkit-line-clamp: 2;
  overflow: hidden;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.2;
  text-overflow: clip;
  white-space: normal;
`
